import React from "react";
import { useLocation } from "react-router-dom";
import { CRow, CCol, CCard, CCardBody, CCardHeader } from "@coreui/react";
import "src/components/reporteVentas/reporteVentas.scss";
import "src/components/reporteCompras/reporteCompras.scss";
import "src/components/reporteRRHH/reporteRRHH.scss";
import "src/components/dashboard/DeudaClientes/styles.scss";
import "src/components/cobranza/CobranzaFacturas/cobranzaFacturas.scss";
import "src/components/general/js/MetricsGroup.scss";
import "./ReportModuleLoadingSkeleton.scss";

/** Línea con shimmer (misma animación que FlujoCaja / flow-skeleton-line) */
function Sk({ className = "", style = {} }) {
  return <div className={`flow-skeleton-line ${className}`.trim()} style={style} />;
}

function ReportCardInner() {
  return (
    <div className="report-card-container">
      <div className="report-card-header">
        <div className="title-section">
          <Sk style={{ width: "75%", height: 14, margin: "0 auto 10px", borderRadius: 6 }} />
          <Sk style={{ width: "48%", height: 10, margin: "0 auto", borderRadius: 6 }} />
        </div>
      </div>
      <div className="report-card-content">
        <div className="report-skeleton-chart-block report-skeleton-chart-block--tall" />
      </div>
    </div>
  );
}

function TableRowsSkeleton({ rows = 8 }) {
  return (
    <div className="flow-initial-skeleton-table report-skeleton-table-embed">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={`tsk-${i}`} className="flow-initial-skeleton-row">
          <div className="flow-skeleton-line flow-skeleton-label" />
          <div className="flow-skeleton-line flow-skeleton-cell" />
          <div className="flow-skeleton-line flow-skeleton-cell" />
          <div className="flow-skeleton-line flow-skeleton-cell" />
          <div className="flow-skeleton-line flow-skeleton-cell" />
          <div className="flow-skeleton-line flow-skeleton-total" />
        </div>
      ))}
    </div>
  );
}

function VentasComprasSkeleton({ containerClass }) {
  return (
    <div className={containerClass}>
      <CRow className="mb-4">
        {[1, 2, 3].map((i) => (
          <CCol key={i} xs="12" md="6" lg="4" className="mb-3 mb-md-0">
            <div className="report-skel-filter-block">
              <Sk style={{ width: 96, height: 11, marginBottom: 8 }} />
              <Sk style={{ width: "100%", height: 38, borderRadius: 8 }} />
            </div>
          </CCol>
        ))}
      </CRow>

      <CRow>
        {[1, 2].map((i) => (
          <CCol key={i} xs="12" lg="6" className="mb-4">
            <div className="metrics-group">
              <div className="metrics-group__header">
                <Sk style={{ width: "72%", height: 16, margin: "0 auto" }} />
              </div>
              <div className="metrics-group__cards">
                {[1, 2, 3].map((j) => (
                  <div key={j} className="metrics-group__card">
                    <Sk style={{ width: "88%", height: 22, marginBottom: 8 }} />
                    <Sk style={{ width: "58%", height: 10 }} />
                  </div>
                ))}
              </div>
            </div>
          </CCol>
        ))}
      </CRow>

      <CRow>
        {[1, 2, 3, 4].map((i) => (
          <CCol key={i} xs="12" className="mb-4">
            <ReportCardInner />
          </CCol>
        ))}
      </CRow>

      <CRow>
        <CCol xs="12">
          <div className="report-card-container">
            <div className="report-card-header">
              <div className="title-section">
                <Sk style={{ width: "52%", height: 14, margin: "0 auto 8px" }} />
                <Sk style={{ width: "36%", height: 10, margin: "0 auto" }} />
              </div>
            </div>
            <div className="report-card-content">
              <TableRowsSkeleton rows={8} />
            </div>
          </div>
        </CCol>
      </CRow>
    </div>
  );
}

function DeudaReportSkeleton() {
  return (
    <CRow>
      <CCol md={12} className="mb-3">
        <CCard className="dp-card" style={{ overflow: "visible" }}>
          <CCardHeader className="card-header">Filtros</CCardHeader>
          <CCardBody style={{ overflow: "visible" }}>
            <div className="dp-filters-container">
              <div className="dp-date-filters">
                <div className="dp-date-input-group">
                  <Sk style={{ width: 52, height: 11, marginBottom: 8 }} />
                  <Sk style={{ width: "100%", height: 36, borderRadius: 8 }} />
                </div>
                <div className="dp-date-input-group">
                  <Sk style={{ width: 48, height: 11, marginBottom: 8 }} />
                  <Sk style={{ width: "100%", height: 36, borderRadius: 8 }} />
                </div>
              </div>
              <div className="dp-provider-filter">
                <Sk style={{ width: "100%", maxWidth: 320, height: 40, borderRadius: 8 }} />
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md={12} className="mb-3">
        <CRow>
          {[1, 2, 3, 4].map((i) => (
            <CCol md={3} key={i}>
              <CCard className="dp-card">
                <CCardBody
                  className="dp-equal-height"
                  style={{
                    textAlign: "center",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Sk style={{ width: "75%", height: 11, margin: "0 auto 14px" }} />
                  <Sk style={{ width: "62%", height: 22, margin: "0 auto" }} />
                </CCardBody>
              </CCard>
            </CCol>
          ))}
        </CRow>
      </CCol>

      <CCol md={12} lg={6} className="mb-3">
        <ReportCardInner />
      </CCol>
      <CCol md={12} lg={6} className="mb-3">
        <ReportCardInner />
      </CCol>
      <CCol md={12} lg={6} className="mb-3">
        <ReportCardInner />
      </CCol>
      <CCol md={12} lg={6} className="mb-3">
        <ReportCardInner />
      </CCol>

      <CCol md={12}>
        <div className="report-card-container">
          <div className="report-card-header">
            <div className="title-section">
              <Sk style={{ width: "58%", height: 14, margin: "0 auto 8px" }} />
              <Sk style={{ width: "40%", height: 10, margin: "0 auto" }} />
            </div>
          </div>
          <div className="report-card-content">
            <TableRowsSkeleton rows={6} />
          </div>
        </div>
      </CCol>
    </CRow>
  );
}

function RrhhSkeleton() {
  return (
    <div className="reporte-rrhh-container">
      <CRow className="mb-4">
        <CCol xs="12" md="6" lg="4" className="mb-3 mb-md-0">
          <div className="cost-center-filter">
            <Sk style={{ width: 120, height: 12, marginBottom: 8 }} />
            <Sk style={{ width: "100%", height: 38, borderRadius: 8 }} />
          </div>
        </CCol>
        <CCol xs="12" md="6" lg="4" className="mb-3 mb-md-0" />
        <CCol xs="12" md="6" lg="4">
          <Sk style={{ width: 48, height: 12, marginBottom: 8 }} />
          <Sk style={{ width: "100%", height: 38, borderRadius: 8 }} />
        </CCol>
      </CRow>

      <CRow className="mb-4">
        {[1, 2, 3, 4].map((i) => (
          <CCol xs="12" md="3" key={i}>
            <div className="metric-card">
              <Sk style={{ width: "88%", height: 11, margin: "0 auto 12px" }} />
              <Sk style={{ width: "72%", height: 22, margin: "0 auto" }} />
            </div>
          </CCol>
        ))}
      </CRow>

      <CRow>
        <CCol xs="12" className="mb-4">
          <ReportCardInner />
        </CCol>
      </CRow>

      <CRow>
        <CCol xs="12" className="mb-4">
          <div className="report-card-container">
            <div className="report-card-header">
              <div className="title-section">
                <Sk style={{ width: "62%", height: 14, margin: "0 auto 8px" }} />
                <Sk style={{ width: "44%", height: 10, margin: "0 auto" }} />
              </div>
            </div>
            <div className="report-card-content">
              <TableRowsSkeleton rows={10} />
            </div>
          </div>
        </CCol>
      </CRow>
    </div>
  );
}

function CobranzaFacturasSkeleton() {
  return (
    <div className="cobranza-facturas-container cf-has-floating-bar">
      <div className="cf-top-row">
        <div className="report-skel-cf-tabs">
          {[1, 2, 3, 4].map((i) => (
            <Sk
              key={i}
              className="flow-skeleton-pill"
              style={{ width: i === 4 ? 140 : 120, height: 34 }}
            />
          ))}
        </div>
        <Sk className="flow-skeleton-pill" style={{ width: 200, height: 34 }} />
      </div>

      <div className="cf-kpi-cards">
        {[1, 2, 3].map((i) => (
          <div key={i} className="cf-kpi-card">
            <Sk style={{ width: "70%", height: 11, margin: "0 auto 10px" }} />
            <Sk style={{ width: "55%", height: 24, margin: "0 auto" }} />
          </div>
        ))}
      </div>

      <div className="cf-header-bar">
        <div className="cf-header-stats">
          <Sk style={{ width: 180, height: 14 }} />
          <Sk style={{ width: 160, height: 14 }} />
        </div>
        <div className="cf-header-filters">
          <Sk style={{ width: 140, height: 32, borderRadius: 8 }} />
          <Sk style={{ width: 260, height: 36, borderRadius: 8 }} />
        </div>
      </div>

      <div className="cobranza-facturas-content">
        <div className="report-card-container" style={{ marginBottom: 0 }}>
          <div className="report-card-content">
            <TableRowsSkeleton rows={10} />
          </div>
        </div>
      </div>
    </div>
  );
}

/** Fallback genérico (lazy) si no hay variante */
function GenericFlowSkeleton() {
  return (
    <div className="report-module-flow-wrap">
      <div className="flow-initial-skeleton">
        <div className="flow-initial-skeleton-toolbar">
          <div className="flow-skeleton-line flow-skeleton-pill" />
          <div className="flow-skeleton-line flow-skeleton-pill" />
          <div className="flow-skeleton-line flow-skeleton-pill" />
        </div>
        <div className="report-skeleton-charts-row">
          <div className="report-skeleton-chart-block report-skeleton-chart-block--tall" />
          <div className="report-skeleton-chart-block report-skeleton-chart-block--tall" />
        </div>
        <div className="flow-initial-skeleton-table">
          {Array.from({ length: 12 }).map((_, index) => (
            <div key={`gen-${index}`} className="flow-initial-skeleton-row">
              <div className="flow-skeleton-line flow-skeleton-label" />
              <div className="flow-skeleton-line flow-skeleton-cell" />
              <div className="flow-skeleton-line flow-skeleton-cell" />
              <div className="flow-skeleton-line flow-skeleton-cell" />
              <div className="flow-skeleton-line flow-skeleton-cell" />
              <div className="flow-skeleton-line flow-skeleton-total" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/**
 * Shimmer para gráficos embebidos (deuda, RRHH, etc.)
 */
export function ChartLoadingSkeleton({ chartHeight = "220px" }) {
  return (
    <div className="chart-loading-skeleton-flow" style={{ minHeight: chartHeight }}>
      <div
        className="report-skeleton-chart-block"
        style={{ height: chartHeight, minHeight: chartHeight }}
      />
    </div>
  );
}

const VARIANT_BY_PATH = {
  "/reportes_ventas": "ventas",
  "/reportes_compras": "compras",
  "/reportes_cobranza": "deuda-clientes",
  "/reportes_proveedores": "deuda-proveedores",
  "/reportes_rrhh": "rrhh",
  "/cobranza": "cobranza-facturas",
};

/**
 * Skeleton alineado al layout real de cada módulo de reportes.
 * @param {string} [variant] — ventas | compras | deuda-clientes | deuda-proveedores | rrhh | cobranza-facturas | generic
 */
export default function ReportModuleLoadingSkeleton({ variant: variantProp }) {
  const { pathname } = useLocation();
  const variant = variantProp || VARIANT_BY_PATH[pathname] || "generic";

  switch (variant) {
    case "ventas":
      return <VentasComprasSkeleton containerClass="reporte-ventas-container" />;
    case "compras":
      return <VentasComprasSkeleton containerClass="reporte-compras-container" />;
    case "deuda-clientes":
    case "deuda-proveedores":
      return <DeudaReportSkeleton />;
    case "rrhh":
      return <RrhhSkeleton />;
    case "cobranza-facturas":
      return <CobranzaFacturasSkeleton />;
    default:
      return <GenericFlowSkeleton />;
  }
}

export { VARIANT_BY_PATH };
